'use client';

import Image from 'next/image';
import './ChampionBanner.scss';
import GlobalButton from '@/components/Button/button';

export interface ChampionBannerProps {
  title: string;
  subtitle?: string;
  imageUrl?: string;
  imageAlt?: string;
  showButton?: boolean;
  btnTxt?: string;
  href?: string;
}

export default function ChampionBanner({
  title,
  subtitle,
  imageUrl,
  imageAlt = 'Champion Banner',
  showButton = false,
  href,
  btnTxt,
}: ChampionBannerProps) {
  return (
    <div className="champion-banner">
      <div className="champion-banner__container">
        <div className="champion-banner__left">
          <h1 className="champion-banner__title">{title}</h1>
          {subtitle && <p className="champion-banner__subtitle">{subtitle}</p>}
          {showButton && (
            <>
              <br />
              <GlobalButton
                color="primary"
                text={btnTxt || ''}
                href={href || '#'}
                target="_blank"
              />
            </>
          )}
        </div>

        <div className="champion-banner__right">
          {imageUrl && (
            <div className="champion-banner__image-wrapper">
              <Image
                src={imageUrl}
                alt={imageAlt}
                width={768}
                height={391}
                priority
                sizes="(max-width: 768px) 100vw, (max-width: 1056px) 50vw, 736px"
                className="champion-banner__image"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
